import { CorreoElectronico } from '../correos-electronico/correos-electronico.model';
import { Telefono } from '../telefonos/telefonos.model';

export interface DatosContacto {
  telefonos: Telefono[];
  correos_electronico: CorreoElectronico[];
}

export function createEmptyDatosContacto(): DatosContacto {
  return {
    telefonos: null,
    correos_electronico: null
  };
}

export function createDatosContacto(params: any): DatosContacto {
  return {
    ...createEmptyDatosContacto(),
    ...params
  };
}
